enum DistributorAttributes {
    globalSalesEnabled = "globalSalesEnabled",
    isLgaEnabled = "isLgaEnabled"
}

export default DistributorAttributes;